'use strict';

angular.module('shiftTraderApp')
    .controller('StoreScheduleCtrl', function ($scope, $location, me, org, theDate, workPeriods, TimeService, $rootScope, $state, $stateParams, NotesQueryManagementService) {
      $rootScope.$broadcast('setTopNavTitle', 'Store Schedule');
      $scope.me = me;
      $scope.org = org;
      $scope.workPeriods = _.where(workPeriods, function(wp) {
        return wp.$isPublished();
      });
      $scope.currentDate = theDate;
      $scope.weekTwix = TimeService.getWeekTwixFromMoment($scope.currentDate);
      $scope.weekOfDayStarts = _.map([0,1,2,3,4,5,6], function(dayNum) {
        return moment($scope.weekTwix.start).add(dayNum, 'days');
      });


      $scope.weekBarLabels = _.map($scope.weekOfDayStarts, function(dt) {
        return dt.format('ddd').toUpperCase();
      });

      $scope.state = {
        notes: null,
        managementId: NotesQueryManagementService.getUniqueId('notes-on-day')
      };

      $scope.theLinkFunction = function(barNum) {
        console.log(barNum);
        return $state.go('storeSchedule.show', {date: $scope.weekOfDayStarts[barNum].format('YYYY-MM-DD')});
      };

      $scope.currentDayOfWeek = _.findIndex($scope.weekOfDayStarts, function(dt) {
        return dt.isSame($scope.currentDate);
      }) + 1;

      $scope.datePickerDate = TimeService.getDateForBeginningOfDayFromMomentWithOrgSetting(moment($scope.currentDate))//.toDate();//format('YYYY-MM-DD');
      $scope.previousDay = moment($scope.currentDate).subtract(1, 'days');
      $scope.previousDayFormatted = $scope.previousDay.format('YYYY-MM-DD');
      $scope.nextDay = moment($scope.currentDate).add(1, 'days');
      $scope.nextDayFormatted = $scope.nextDay.format('YYYY-MM-DD');

      // Set the query based on the current date of the page

      $scope.$watch('datePickerDate', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          $state.go('storeSchedule.show', {date: moment(newVal).format('YYYY-MM-DD')});
        }
      });

      $scope.inferredPositions = _.unique(_.map($scope.workPeriods, function(wp) {
        return {
          id: wp.position.id,
          department_id: wp.position.department_id,
          name: wp.position.name
        };
      }), 'id');

      $scope.departments = _.map($scope.org.departments, function(dept) {
        dept.positions = [];
        return dept;
      });

      _.each($scope.inferredPositions, function(pos) {
        _.each($scope.departments, function(dept) {
          if (dept.id === pos.department_id) {
            dept.positions.push(pos);
          }
        });
      });

      $scope.workPeriodsByPosId = {};
      _.each($scope.inferredPositions, function(pos) {
        $scope.workPeriodsByPosId[pos.id] = _.where($scope.workPeriods, function(wp) {
          return wp.position.id === pos.id;
        });
      });

      $scope.getLinkUrl = function(wp) {
        return '#/workPeriods/' + wp.id;
      };

      $scope.layout = {
        name: 'layout-date-only',
        data: {
          date: $scope.currentDate
        }
      };
    });
